export default {
    path: 'social',
    component: () => import('../Social.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách trang Mạng xã hội',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo trang Mạng xã hội',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chi tiết trang Mạng xã hội',
            component: () => import('../cu/CU.vue'),
        },
    ]
};